import { render, staticRenderFns } from "./PendingBalanceLetter.vue?vue&type=template&id=40a85dc4&scoped=true&"
import script from "./PendingBalanceLetter.vue?vue&type=script&lang=js&"
export * from "./PendingBalanceLetter.vue?vue&type=script&lang=js&"
import style0 from "./PendingBalanceLetter.vue?vue&type=style&index=0&id=40a85dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a85dc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VProgressLinear,VSpacer})
